import { createAction } from 'redux-actions';
export const EXIT_SEARCH_AND_FILTER_MODE = 'EXIT_SEARCH_AND_FILTER_MODE';
export const exitSearchAndFilterMode = createAction(EXIT_SEARCH_AND_FILTER_MODE);